import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { AuthenticationCheckService } from 'src/app/services/auth/authentication-check.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Location } from '@angular/common';
import { filter, pairwise } from 'rxjs/operators';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
})
export class SigninComponent implements OnInit {
  loginForm: any;
  setupForm: any;
  ClearDbForm: any;
  tempOptionModel: any;
  programs: any = [];
  errorMessage: Boolean = true;
  submitted = false;
  passwordSubmitted = false;
  hideClearDB: boolean = true;
  clearDBsubmit = false;

  inputPasswordType: string = 'password';

  userType: any = '';
  smloginForm: any;
  otpForm: any;
  userData: any;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private formBuilder: FormBuilder,
    private auth: AuthenticationCheckService,
    private toast: ToastClientService,
    public modalService: NgbModal,
    public location: Location
  ) {
    this.checkLogin();
    this.loginForm = formBuilder.group({
      username: ['', Validators.compose([Validators.required])],
      password: [
        '',
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
      program_id: ['1', Validators.compose([Validators.required])],
    });
    this.setupForm = formBuilder.group({
      password: [
        '',
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
    });

    this.ClearDbForm = formBuilder.group({
      password: [
        '',
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
      program_id: ['1', Validators.compose([Validators.required])],
    });

    this.smloginForm = formBuilder.group({
      program_id: ['', Validators.compose([Validators.required])],
      mobile_no: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(10),
          Validators.maxLength(10),
        ]),
      ],
      password: [
        '',
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
    });

    // this.otpForm = formBuilder.group({
    //   otp: ['', Validators.compose([
    //     Validators.required,
    //     Validators.pattern("^[0-9]*$"),
    //     Validators.minLength(6),
    //     Validators.maxLength(6)
    //   ])],

    // });

    this.loginForm.valueChanges.subscribe((data) => { });
  }
  get c() {
    return this.loginForm.controls;
  }
  get p() {
    return this.setupForm.controls;
  }
  get db() {
    return this.ClearDbForm.controls;
  }
  get f() {
    return this.smloginForm.controls;
  }
  get v() {
    return this.otpForm.controls;
  }

  ngOnInit() {
    this.getPrograms();
  }

  checkLogin() {
    // debugger
    let previousURL = localStorage.getItem('previousURL');
    let login = localStorage.getItem('login');
    if (login == 'true') {
      this.router.navigateByUrl(previousURL);
    }
  }

  getPrograms() {
    this.apiService.get(this.apiConfig.get_all_the_programs).subscribe(
      (res: any) => {
        this.programs = res.data;
        // this.programs = [];
      },
      (err) => { }
    );
  }

  toggleShowPassword() {
    this.inputPasswordType == 'password'
      ? (this.inputPasswordType = 'text')
      : (this.inputPasswordType = 'password');
    setTimeout(() => {
      this.inputPasswordType = 'password';
    }, 1000);
  }

  programSetup(formData) {
    this.passwordSubmitted = true;
    if (this.setupForm.invalid) {
      return;
    }
    if (formData.password == 123456) {
      this.router.navigateByUrl('create-new-program');
    } else {
      this.errorMessage = false;
    }
    // this.apiService.get(this.apiConfig.setupProgram + formData.password)
    //   .subscribe((res: any) => {
    //     this.toast.Success('Project setup successfully completed');
    //     this.getPrograms();
    //   }, err => {
    //     // this.toast.Error(err.message)
    //   })
  }

  // smLogin(formData, type) {
  //   //console.log("formData", formData);
  //   this.submitted = true;
  //   if (this.smloginForm.invalid) {
  //     return
  //   }
  //   let apiUrl = this.apiConfig.rsm_Login;
  //   let body = { "mobile_no": formData.mobile_no, "source_from": 2, "password": formData.password, "program_id": 1 };
  //   window.localStorage.setItem('program', JSON.stringify({ program_id: 1 }));

  //   this.apiService.post(apiUrl, body)
  //     .subscribe((res: any) => {
  //       //console.log("response login", res);
  //       if (res.status == 200) {
  //         this.errorMessage = true;
  //         let body = res.body;
  //         this.toast.Success('Login Successfully');
  //         localStorage.setItem("user_name", (res.body.data.user_name));
  //         localStorage.setItem("user_id", (res.body.data.id));
  //         window.localStorage.setItem("program", JSON.stringify(res.body.data));
  //         this.auth.saveAuth(body.data.access_token);
  //         this.submitted = false;
  //         if (body.data.user_role == 9) {
  //           this.router.navigate(["regional-sales-manager"]);
  //         }
  //         else {
  //           this.toast.Success('You dont have access to this module');
  //         }
  //       }
  //     }, err => {
  //       this.errorMessage = false;
  //       //
  //     })
  // }

  // verifyOTP(formData) {
  //   this.submitted = true;
  //   //
  //   if (this.otpForm.invalid) {
  //     return
  //   }
  //   let apiUrl = this.apiConfig.verifyOtp;
  //   let body = {
  //     "otp": formData.otp,
  //     "user_id": this.userData.user_id,
  //     "program_id": this.userData.program_id,
  //     "app_version": 1,
  //     "self_enrollment_flag": 1
  //   };
  //   window.localStorage.setItem('program', JSON.stringify({ program_id: this.userData.program_id }));

  //   this.apiService.post(apiUrl, body)
  //     .subscribe((res: any) => {
  //       // console.log("otp login", res)
  //       if (res.status == 200) {
  //         this.errorMessage = true;
  //         let body = res.body;
  //         this.toast.Success('Login Successfully');
  //         localStorage.setItem("user_name", (res.body.data.user_name));
  //         localStorage.setItem("user_id", (res.body.data.id));
  //         window.localStorage.setItem("program", JSON.stringify(res.body.data));
  //         this.auth.saveAuth(body.data.access_token);
  //         this.submitted = false;
  //         if (body.data.user_role == 9) {
  //           this.router.navigate(["regional-sales-manager"]);
  //         }
  //         else {
  //           this.toast.Success('You dont have access to this module');
  //         }
  //       }
  //     }, err => {
  //       this.errorMessage = false;
  //       //
  //     })
  // }

  login(formData) {
    //debugger
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    let apiUrl = this.apiConfig.login;
    let body = JSON.stringify({
      LoginForm: {
        username: formData.username,
        password: formData.password,
        program_id: formData.program_id,
      },
    });
    window.localStorage.setItem(
      'program',
      JSON.stringify({ program_id: formData.program_id })
    );

    this.apiService.post(apiUrl, body).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.errorMessage = true;
          let body = res.body;
          this.toast.Success('Login successful');
          localStorage.setItem('user_name', res.body.data.user_name);
          localStorage.setItem('user_id', res.body.data.id);
          window.localStorage.setItem('program', JSON.stringify(res.body.data));
          this.auth.saveAuth(body.data.access_token);


          this.submitted = false;
          if (
            body.data.user_role == 1 ||
            body.data.role_name == 'Organization' ||
            body.data.profile_code == 'GNRL'
          ) {
            this.router.navigate(['hubAdmin']);
            this.callProgramConfigApi();
          } else if (body.data.user_role == 9) {
            console.log('ddd33', res.body.data.regions, res.body.data.states);
            localStorage.setItem(
              'rsm_regions',
              JSON.stringify(res.body.data.regions)
            );
            localStorage.setItem(
              'rsm_states',
              JSON.stringify(res.body.data.states)
            );
            //added now
            // this.router.navigate(['regional-sales-manager']);

            const schemaTokens = body.data.schema_tokens || {};
            const isWellaPlusUser = !!schemaTokens.device_token;

            console.log('iswella',isWellaPlusUser)

            if (isWellaPlusUser) {
              console.log('wella plus')
              this.router.navigate(['/regional-sales-manager/dashboard']);
            } else {
              console.log('not wella plus')
              //added now
              const programCode = body.data.program_code || {};
              const firstGroupCode = programCode.group_code || '';

              console.log(programCode, 'grpcd');
              console.log(firstGroupCode, 'fstgrpcd');

              localStorage.setItem('application_id', firstGroupCode);
              localStorage.setItem('group_code', firstGroupCode);

              const userSchemas = body.data.user_schema || [];
              const firstSchemaName = userSchemas.length > 0 ? userSchemas[0] : '';

              localStorage.setItem('selected_schema_name', firstSchemaName);
              localStorage.setItem(
                'selectedSchema',
                JSON.stringify({
                  group_code: firstGroupCode,
                  schema_name: firstSchemaName
                })
              );

              this.router.navigate(['/regional-sales-manager/new-dashboard']);
            }

          } else if (body.data.role_name == 'Staff') {
            this.router.navigate(['teamleader']);
          } else if (body.data.role_name == 'Agent') {
            this.router.navigate(['agent']);
          } else if (body.data.role_name == 'Redemption') {
            this.router.navigate(['redemption']);
          } else if (body.data.role_name == 'Reporting') {
            this.router.navigate(['reports']);
          } else if (body.data.user_role == 25) {
            this.router.navigate(['operationalhead']);
          } else if (body.data.user_role == 27) {
            this.router.navigate(['authorization']);
          } else if (body.data.user_role == 28) {
            this.router.navigate(['finance']);
          } else if (body.data.user_role == 26) {
            // console.log(body.data.role_name,'role_name');
            this.router.navigate(["concierge"]);
          }
          else {
            this.toast.Success('You dont have access to this module');
          }
        }
      },
      (err) => {
        this.errorMessage = false;
        //
      }
    );
  }

  // selectUT($ev) {
  //   // console.log("hggg", $ev);
  //   this.userType = $ev;
  //   this.submitted = false;
  //   if (this.userType != 1) {
  //     // set program id for user type = 2
  //     this.smloginForm.controls.program_id.setValue('4');
  //   }
  // }

  isValid(field): boolean {
    let isValid: boolean = false;

    // If the field is not touched and invalid, it is considered as initial loaded form. Thus set as true
    if (this.loginForm.controls[field].touched == false) {
      isValid = true;
    }
    // If the field is touched and valid value, then it is considered as valid.
    else if (
      this.loginForm.controls[field].touched == true &&
      this.loginForm.controls[field].valid == true
    ) {
      isValid = true;
    }
    return isValid;
  }

  toggleView() {
    this.hideClearDB = !this.hideClearDB;
  }

  modalRef;
  ClearDbSubmit(value, target) {
    this.clearDBsubmit = true;
    if (this.ClearDbForm.invalid) {
      return;
    }
    this.modalRef = this.modalService.open(target, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
      scrollable: true,
      windowClass: '',
    });
    this.modalRef.result.then((result) => {
      if (result) {
      }
    });
  }

  clearDB(value) {
    // return

    let sendData = {
      pwd: value.password,
      program_id: value.program_id,
    };
    // return
    this.apiService
      .get(this.apiConfig.clearDataBase + '?pwd=' + value.password)
      .subscribe(
        (res: any) => {
          this.toggleView();
          this.modalRef.dismiss();
          this.toast.Success('Database cleared successfully');
          this.getPrograms();
        },
        (err) => { }
      );
  }

  callProgramConfigApi() {
    let apiUrl = this.apiConfig.programConfig;
    this.apiService.get(apiUrl).subscribe(
      (res: any) => {
        if (res.status == 200) {
          //
          localStorage.setItem('has_beat', res.data.has_beat);
          localStorage.setItem('has_channel', res.data.has_channel);
          this.apiService.$beatResonseData.emit(res.data.has_beat);
          this.apiService.$channelResonseData.emit(res.data.has_channel);
        }
      },
      (err) => { }
    );
  }
}
